import {FC, useState, createContext, useContext, useMemo, useEffect, Dispatch, SetStateAction} from 'react'
import {
    ID,
    calculatedGroupingIsDisabled,
    calculateIsAllDataSelected,
    groupingOnSelect,
    initialListView,
    ListViewContextProps,
    groupingOnSelectAll,
    WithChildren, QUERIES,
} from '../../../../_metronic/helpers'
import {Task} from './_models'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProvider'
import {useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {getProjectById, getProjectsTask} from "../../project/components/core/_requests";
import {Project} from "../../project/components/core/_models";

type ExtraListViewContextProps = {
  tasks: Task[]
  setTasks: Dispatch<SetStateAction<Task[]>>
  updateCellData: (rowIndex: number, columnId: number, value: any) => void
  addRow: () => void
  removeRow: () => void
}

type CustomListViewContextProps = ListViewContextProps & ExtraListViewContextProps

const extraInitialListView: ExtraListViewContextProps = {
  tasks: [],
  setTasks: () => {},
  updateCellData: () => {},
  addRow: () => {},
  removeRow: () => {},
}

const ListViewContext = createContext<CustomListViewContextProps>(Object.assign(initialListView, extraInitialListView))

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const [taskIdForUpdate, setTaskIdForUpdate] = useState<ID>(initialListView.taskIdForUpdate)
  const [holidayIdForUpdate, setHolidayIdForUpdate] = useState<ID>(initialListView.holidayIdForUpdate)
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const [tasks, setTasks] = useState<Task[]>(data)
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])
  const {project_id} = useParams()

  useEffect(() => {
    setTasks(data)
  }, [data])


  const updateCellData = (rowIndex: number, columnId: number, value: any) => {
    setTasks(tasks =>
      tasks.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...tasks[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }


  const addRow = () => {
    // Calcular o menor order_mytasks para que a nova tarefa apareça primeiro
    const minOrder = tasks.length > 0 ? Math.min(...tasks.map(task => task.order_mytasks || 0)) - 1 : 0

    const emptyRow = {
      id: tasks.length+1,
      name: "",
      status: "Backlog",
      color: "primary",
     // users: [],
     // usersAll:project?.users,
      users: [],
      usersAll: [],
      description: "",
      total_time: 0,
      play: 'pause',
      order_mytasks: minOrder
    }

    setTasks(tasks => [emptyRow, ...tasks]) // Adicionar no início da lista
   // insertTask();
  }
  const removeRow = () => {
    // if(tasks.filter(task => task.name === '').length) return
    setTasks(tasks.filter(task => task.name !== ''))
  }

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        taskIdForUpdate, 
        setTaskIdForUpdate,
        holidayIdForUpdate,
        setHolidayIdForUpdate,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
        tasks,
        setTasks,
        updateCellData,
        addRow,
        removeRow
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
